import {createContext} from "react";

export const topUpContext: any = createContext(null)
export const PopupContext: any = createContext(null)